import { brandFeatures } from '@/mocks/laceData';

export default function BrandFeatures() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="mx-auto" style={{ maxWidth: '1280px' }}>
        <div className="text-center mb-12">
          <p className="text-accent-600 text-sm tracking-[0.2em] uppercase mb-3 font-label">Why Choose Us</p>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-4">
            为什么选择蕾丝雅集
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            我们致力于将最优质的蕾丝产品和服务带给每一位追求精致生活的你。
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {brandFeatures.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70 text-center hover:border-accent-300 transition-colors duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${feature.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}